import { ShutDownIcon } from "@/shared/icons";
import { Button } from "@/shared/ui";
import useExit from "@/domains/account/hooks/useExit";

export default function AccountExitContainer() {
  const { exit, isPending } = useExit();

  return (
    <Button
      variant="solid-surface-gradient"
      className="w-full mt-auto shrink-0 h-11"
      onClick={exit}
      loading={isPending}
      disabled={isPending}
    >
      <ShutDownIcon size={16} className="mr-2.5" />
      Выйти на рабочий стол
    </Button>
  );
}
